<template>
    <div class="row">
        <div class="col-12 col-md-7">
            <div class="card">
                <div class="card-header bg-info my-0 mx-0">
                    <h4 class="my-0">Registrar Cliente en GIOR</h4>
                </div>
                <div class="card-body my-0 mx-0">
                    <div class="row">
                        <div class="col-12">
                            <div class="form-group">
                                <label class="control-label">Cliente</label>
                                <el-select v-model="client_id"
                                    placeholder="Seleccione un cliente"
                                    clearable
                                    filterable
                                    remote
                                    :remote-method="searchClients"
                                    :loading="select_loading"
                                    @change="onClientChange"
                                >
                                    <el-option v-for="(client, index) in clients"
                                        :key="index"
                                        :label="client.name + ' - ' + client.number + ' - ' + client.fqdn"
                                        :value="client.id"
                                    ></el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="form-group">
                                <label class="control-label">RUC</label>
                                <el-input v-model="form.ruc"
                                    placeholder="Ingrese el RUC"
                                    disabled
                                ></el-input>
                            </div>
                        </div>
                        <div class="col-12 mt-3">
                            <div class="form-group">
                                <el-checkbox label="Solo Validación OSE"
                                    v-model="form.is_ose_validation_only"
                                    :disabled="data_client_loading"
                                ></el-checkbox>
                                <el-tooltip effect="dark"
                                    content="Si se activa esta opción, el sistema solo validará los comprobantes a través del OSE GIOR, y no podrá usar PSE GIOR y la configuración de Entorno de Sistema (SOAP Envio)."
                                    placement="top">
                                    <i class="fa fa-info-circle"></i>
                                </el-tooltip>
                            </div>
                        </div>
                    </div>
                    <el-divider></el-divider>
                    <div class="row" v-loading="data_client_loading">
                        <template v-if="hasDataClientNotNull">
                            <div class="col-12">
                                <el-alert type="success"
                                    title="Datos del Cliente en GIOR"
                                    show-icon
                                    :closable="false"
                                ></el-alert>
                            </div>
                        </template>
                        <div class="col-12 col-md-6">
                            <div class="form-group">
                                <label class="control-label">
                                    Usuario Api
                                </label>
                                <el-input v-model="data_client.api_username"
                                    placeholder="Usuario API"
                                    disabled
                                ></el-input>
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group">
                                <label class="control-label">
                                    Contraseña Api
                                </label>
                                <el-input v-model="data_client.api_password"
                                    placeholder="Contraseña API"
                                    disabled
                                ></el-input>
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group">
                                <label class="control-label">
                                    Usuario Web
                                </label>
                                <el-input v-model="data_client.web_username"
                                    placeholder="Usuario Web"
                                    disabled
                                ></el-input>
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group">
                                <label class="control-label">
                                    Contraseña Web
                                </label>
                                <el-input v-model="data_client.web_password"
                                    placeholder="Contraseña Web"
                                    disabled
                                ></el-input>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 text-right mt-3">
                            <el-button type="primary"
                                native-type="button"
                                :loading="loadingSubmitForm"
                                @click="submitForm"
                            >
                                {{ hasDataClientNotNull ? 'Actualizar' : 'Registrar' }}
                            </el-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            client_id: null,
            form: {},
            clients: [],
            data_client: {},
            entities: [
                {
                    id: 1,
                    name: 'OSE GIOR'
                }
            ],
            timer: null,
            select_loading: false,
            data_client_loading: false,
            loadingSubmitForm: false
        }
    },

    watch: {
        'form.is_ose_validation_only': {
            handler(newValue) {
                if (newValue) {
                    this.form.integration_type = null
                } else {
                    this.form.integration_type = 0
                }
            }
        }
    },

    computed: {
        hasDataClientNotNull() {
            return Object.values(this.data_client).some(value => Boolean(value))
        }
    },

    async created() {
        this.initForm()
        this.initDataClient()
        await this.getClients()
    },

    methods: {
        initForm() {
            this.form = {
                ruc: null,
                company_name: null,
                email: null,
                phone_number: null,
                mobile_number: null,
                validator_entity: 1,
                external_ose_username: null,
                external_ose_password: null,
                is_ose_validation_only: false,
                integration_type: 0,
                website: null
            }
        },

        initDataClient() {
            this.data_client = {
                api_username: null,
                api_password: null,
                web_username: null,
                web_password: null,
            }
        },

        async getClients(param = null) {
            try {
                const response = await this.$http.post('/pse/clients',{
                    param: param
                })
                const { data } = response
                if (data.success) {
                    this.clients = data.data
                }
            } catch (error) {
                this.$message.error(error.response.data.message)
            }
        },

        async getDataClientInPse() {
            try {
                this.data_client_loading = true
                const response = await this.$http.post('/pse/data-client',{
                    website: this.form.website
                })
                const { data } = response
                if (data.success) {
                    this.data_client = data.data
                    this.form.is_ose_validation_only = Boolean(data.data.is_ose_gior_validation_only)
                }
            } catch (error) {
                this.$message.error(error.response.data.message)
            } finally {
                this.data_client_loading = false
            }
        },

        async onClientChange() {
            const selectedClient = this.clients.find(client => client.id === this.client_id)
            if (selectedClient) {
                this.form.ruc = selectedClient.number
                this.form.company_name = selectedClient.name
                this.form.website = selectedClient.website

                await this.getDataClientInPse()
            } else {
                this.initForm()
                this.initDataClient()
            }
        },

        async searchClients(input) {
            this.select_loading = true
            clearTimeout(this.timer)
            this.timer = setTimeout(async () => {
                await this.getClients(input)
                this.select_loading = false
            }, 100)
        },

        async submitForm() {
            try {
                this.loadingSubmitForm = true
                const response = await this.$http.post('/pse/register-client', this.form)
                const { data } = response
                if (data.success) {
                    this.$message.success(data.message)

                    if (data.data) {
                        this.data_client.api_username = data.data.access_api.username
                        this.data_client.api_password = data.data.access_api.password
                        this.data_client.web_username = data.data.access_web.username
                        this.data_client.web_password = data.data.access_web.password
                    }
                } else {
                    this.$message.error(data.message)
                }
            } catch (error) {
                let message = error.response.data.message || 'Error al registrar cliente'
                this.$message.error(message)
            } finally {
                this.loadingSubmitForm = false
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// resources/js/views/tenant/pse/register.vue